import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl06 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_06",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Arrow",
				className: "black",
				d: "M55.92,43.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-5-5c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.29,3.29h-9.59c-.55,0-1,.45-1,1s.45,1,1,1h9.59l-3.29,3.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5-5c.09-.09.17-.2.22-.33Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Eye",
				className: "black",
				d: "M43,14c3.69,0,6.41,2.19,9.78,6.38.16.19.22.41.22.62s-.06.44-.22.62c-3.38,4.22-6.09,6.38-9.78,6.38-3.47,0-5.94-1.69-9.78-6.38-.16-.19-.22-.41-.22-.62s.06-.44.22-.62c3.38-4.19,6.09-6.38,9.78-6.38ZM43,16c-2.53,0-4.69,1.41-7.72,5,2.94,3.5,4.97,4.91,7.72,5,2.53,0,4.69-1.41,7.72-5-2.94-3.5-4.97-4.91-7.72-5ZM43,18c1.66,0,3,1.34,3,3s-1.34,3-3,3-3-1.34-3-3,1.34-3,3-3ZM43,20c-.56,0-1,.47-1,1,0,.56.44,1.03,1,1.03s1-.47,1-1.03c0-.53-.44-1-1-1Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "ICE_Sideview",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M37,49H12c-.55,0-1-.45-1-1s.45-1,1-1h25c.55,0,1,.45,1,1s-.45,1-1,1Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M28,53H12c-.55,0-1-.45-1-1s.45-1,1-1h16c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-3.69c-.55,0-1-.45-1-1s.45-1,1-1h3.69c5.49,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M24.76,42.78s-.1,0-.15-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-2.09c-.55,0-1-.45-1-1s.45-1,1-1h2.09c3.64,0,7.01.24,10.31.72l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-3c-.55,0-1-.45-1-1s.45-1,1-1h3c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.45.43.48.74s-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl06;
